// Moving a booking from the Bookings page: which bookings may move, and what a failed move means in
// words staff can act on. test/booking-moves.test.ts holds this to the server. Everything here is
// English, translated where it is rendered.

/**
 * Which bookings staff can move: confirmed and still ahead, the same ones that can be cancelled here.
 * The server refuses anything but a confirmed booking (rescheduleBooking), and the Android app offers
 * Reschedule only on open (confirmed) bookings, never on completed, cancelled or no-show ones.
 */
export const canReschedule = (b, now) => b.status === "confirmed" && Date.parse(b.start_at) >= now;

/**
 * The keys are the codes of BookingError (src/scheduling/bookings.ts), which the API returns as
 * error.code. The server's own message is written for the AI agent and is never shown.
 */

export const BOOKING_ERRORS = {
  slot_unavailable: "That time was just taken. The booking wasn't moved; pick another time.",
  invalid_state: "This booking can no longer be moved: it was cancelled, completed or marked as a no-show. Reload the page to see its status.",
  booking_not_found: "This booking no longer exists. Reload the page.",
  service_not_found: "This booking's service was removed or switched off, so it can't be moved. Turn the service back on in Services & staff.",
  location_not_offered: "This service is no longer offered the way this booking was made. Check the service in Services & staff.",
};

export const BOOKING_ERROR_FALLBACK = "The booking couldn't be moved. Try again.";

/** English text for a failed booking action: the code's explanation, or the generic line. */
export function bookingErrorText(err) {
  return BOOKING_ERRORS[err?.code] ?? BOOKING_ERROR_FALLBACK;
}
